import { render, staticRenderFns } from "./EntityDetailedCardViewForPublic.vue?vue&type=template&id=0074e912&scoped=true"
import script from "./EntityDetailedCardViewForPublic.vue?vue&type=script&lang=js"
export * from "./EntityDetailedCardViewForPublic.vue?vue&type=script&lang=js"
import style0 from "./EntityDetailedCardViewForPublic.vue?vue&type=style&index=0&id=0074e912&prod&lang=scss&scoped=true"
import style1 from "./EntityDetailedCardViewForPublic.vue?vue&type=style&index=1&id=0074e912&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0074e912",
  null
  
)

export default component.exports